'use strict';

document
.getElementById('message-form')
.addEventListener('submit', function (event) {
  event.preventDefault();
});

